export default __webpack_public_path__ + "static/media/ae.50307485.jpg";